import { render } from "./ModalDowloads.vue?vue&type=template&id=08936b27"
import script from "./ModalDowloads.vue?vue&type=script&lang=js"
export * from "./ModalDowloads.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__